import { atom } from "recoil";

export const deleteModalState = atom({
  key: "deleteModalState", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
